// =============================================================
// EDITABLE SITE CONTENT
// -------------------------------------------------------------
// Change anything below to update the website copy, services,
// contact info, testimonials, footer, etc. Nothing else in the
// codebase needs to be touched for typical content edits.
// =============================================================
import heroBg from "../assets/background.jpeg"; // Adjust relative path as needed

export const siteContent = {
  brand: {
    name: "SquadRCM Healthcare",
    fullName: "SquadRCM Private(opc) Limited ", 
    tagline: "Medical Billing and Coding Company",
    logoText: "SquadRCM ",
    logoAccent: "Health Connected Services",
  },

  contact: {
    phone: "+1 (520) 274-3351",
    phoneHref: "tel:+15203672334",
    email: "support@squadrcm.com",
    website: "www.squadrcm.com",
    addressLine1: "#504, Rajarajeshwari Nagara, ",
    addressLine2: "BEML Layout, Bogadi 2nd Stage, Mysore",
    addressLine3: "Karnataka -570 022",
    workingHours: "Mon - Fri: 9:00 AM - 7:00 PM",
    socials: {
      facebook: "#",
      twitter: "#",
      instagram: "#",
      linkedin: "#",
    },
  },

  nav: [
    { label: "Home", to: "/" },
    { label: "Solutions", to: "/solutions" },
    { label: "About Us", to: "/about" },
    { label: "Contact Us", to: "/contact" },
  ],

  hero: {
    kicker: "Trusted RCM Partner Since 2016",
    titleTop: "",
    titleBottom: "SquadRCM Private(opc) Limited",
    subtitle: "Health Connected Services",
    description:
      "SquadRCM revolutionizes healthcare revenue cycle management. Our team of experts maximizes financial perfomance through streamlined Solutions.",
    primaryCta: { label: "Contact Us", to: "/contact" },
    secondaryCta: { label: "Discover More", to: "/solutions" },
    backgroundImage:heroBg,
  },

  servicesSection: {
    kicker: "Best Services Offered!",
    title: "Different types of Solutions",
    services: [
      {
        icon: "FlaskConical",
        title: "Expert Assistance and Start up solutions for Clinical and Pathological labs",
        excerpt:
          "If you are a new physician group or a laboratory planning to set up, we help you get running smoothly with tailored operational blueprints.",
        slug: "expert-assistance",
      },
      {
        icon: "ShieldCheck",
        title: "Insurance Verification",
        excerpt:
          "The current health care system has created confusion about health insurance not only among healthcare providers but also among patients.",
        slug: "insurance-verification",
      },
      {
        icon: "FileText",
        title: "Medical Billing and Coding",
        excerpt:
          "Apart from Patient Demographic and eligibility related denials, coding denials are directly proportional to a practice's integrity and revenue.",
        slug: "medical-billing",
      },
      {
        icon: "Wallet",
        title: "Credit Balance Validation",
        excerpt:
          "Credit balances are a part of everyday life in a physician's practice or hospital. Smaller credits should not compromise your compliance.",
        slug: "credit-balance",
      },
      {
        icon: "RefreshCcw",
        title: "360° Revenue Cycle Management",
        excerpt:
          "SquadRCM Healthcare is a committed service provider of revenue cycle processing and receivables management, end to end.",
        slug: "rcm",
      },
      {
        icon: "BellRing",
        title: "Appointment Reminder",
        excerpt:
          "Patient care is not just providing treatments, it starts from a personal reminder well in advance about their appointment.",
        slug: "appointment-reminder",
      },
    ],
  },

  about: {
    kicker: "About Solutions",
    title: "Our Strengths & Expertise",
    image:
      "https://images.pexels.com/photos/5452247/pexels-photo-5452247.jpeg",
    points: [
      {
        title: "360° Revenue Cycle Management",
        body: "SquadRCM is a leading provider of revenue cycle management services. If you are a hospital, physician, Independent Lab, or a practice, then you are with a right business partner who is committed to achieve reduction in cost of collection, improve efficiency, increase cash flow and gain patient satisfaction.",
      },
      {
        title: "Expert Assistance",
        body: "Whether you are setting up a new lab or planning to setup a practice, or running an established one, SquadRCM can assist you by providing the industrial expertise towards billing, coding and credentialing solutions customized to your requirements — increasing collections significantly by 10-20%.",
      },
      {
        title: "Account Receivables Follow-up",
        body: "We understand that account receivables are the heart of cash flow and demand rigorous, sincere follow-up efforts to keep aged AR in control. We ensure every service performed gets paid for — completely and promptly.",
      },
    ],
  },

  whyChoose: {
    kicker: "Why Choose Us",
    title: "Trusted & Experienced Medical Care Provider",
    image:
      "https://images.pexels.com/photos/27086922/pexels-photo-27086922.jpeg",
    stats: [
      { value: "10+", label: "Years Experience" },
      { value: "100+", label: "Happy Clients" },
      { value: "98%", label: "Clean Claims" },
      { value: "20%", label: "Collections Boost" },
    ],
    highlights: [
      "HIPAA-compliant secure operations",
      "Dedicated account managers",
      "Transparent monthly reporting",
    ],
  },

  testimonials: [
    {
      quote:
        "I have collaborated extensively with the SquadRCM team over the last several years. They possess a thorough and complete understanding of the US medical billing industry, and have proven to be an extremely valuable partner to me, my companies, and clients. I give them my highest recommendation.",
      name: "John Cucci",
      title: "Chief Sales Officer",
      company: "AcuPath Labs",
    },
    {
      quote:
        "The SquadRCM team continues to be an integral part of our business operations. We have relied on them extensively to handle the billing needs of our business. They have always maintained the highest levels of professionalism, reliability, and accessibility.",
      name: "Hutch Effman",
      title: "Operations Director",
      company: "Suncoast Medical",
    },
    {
      quote:
        "I had the pleasure of working with SquadRCM for 3 years. Their skills included superlative attention to detail, rapid response to addressing issues, and an ability to negotiate with insurance companies on our behalf. Their efforts have saved us vast amounts of money.",
      name: "Dr. Philip McAndrew",
      title: "Medical Director",
      company: "University of Gastroenterology, Rhode Island",
    },
  ],

  footer: {
    about:
      "An enterprise built by young and inspiring people established in mid-2016. A privately owned and passionately independent company with a management team that boasts more than 10 years of experience in RCM process.",
    quickLinks: [
      { label: "Solutions", to: "/solutions" },
      { label: "About Us", to: "/about" },
      { label: "Contact Us", to: "/contact" },
    ],
    solutionsColA: [
      "Expert Assistance and Clinical and Pathological labs",
      "Insurance Verification",
      "Medical Billing and Coding",
      "Credit balance Validation",
      "360° Revenue Cycle Management",
      "Risk-adjustment Coding",
    ],
    solutionsColB: [
      "Appointment Reminder",
      "Auto Charge posting and payment posting",
      "Account Receivables follow up and Denial Management",
      "Insurance Credentialing and Contracts",
      "Weekly, Monthly Reports, Analytics & Account Health Dashboards",
    ],
    certifications: "",
    copyright: "© 2026 SquadRCM Private(opc) Private Limited. All Rights Reserved.",
  },
};

export default siteContent;
